import { FeatureFlags } from "@utils/FeatureFlags/generated-flags";
import { useFlags } from "launchdarkly-react-client-sdk";
import { useState } from "react";
import { useSearchParams } from "react-router-dom";

import { Button, Headline, TabNavigation } from "@fronterahealth/frontera-ui-components";

import { CaregiversTab } from "@pages/Members/components/CaregiversTab";
import { ProvidersTab } from "@pages/Members/components/ProvidersTab";
import { MembersTab } from "@pages/Members/membersTab";

export const Members: React.FC = () => {
  const { "portal-caregiver-activation-invites": caregiversTabEnabled } = useFlags<FeatureFlags>();
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTab: MembersTab =
    searchParams.get("tab") === MembersTab.Caregivers && caregiversTabEnabled
      ? MembersTab.Caregivers
      : MembersTab.Providers;
  const setActiveTab = (tab: MembersTab) => setSearchParams({ tab }, { replace: true });
  const [buttonContainer, setButtonContainer] = useState<HTMLDivElement | null>(null);

  return (
    <div className="mx-auto flex w-full flex-col content-between items-center lg:flex-col lg:items-start">
      <div className="mt-10 flex w-full items-center justify-between">
        <Headline size="medium">User Management</Headline>
        <div ref={setButtonContainer} className="flex items-center space-x-2" />
      </div>

      <div className="w-full">
        <TabNavigation
          tabs={[
            {
              name: "Providers",
              type: "component",
              current: activeTab === MembersTab.Providers,
              Component: (
                <Button
                  text="Providers"
                  variant="primary"
                  buttonStyle="ghost"
                  className={`hover:text-primary ${activeTab === MembersTab.Providers ? "text-limestone-900" : "text-text-secondary"}`}
                  onClick={() => setActiveTab(MembersTab.Providers)}
                />
              ),
            },
            ...(caregiversTabEnabled
              ? [
                  {
                    name: "Caregivers",
                    type: "component" as const,
                    current: activeTab === MembersTab.Caregivers,
                    Component: (
                      <Button
                        text="Caregivers"
                        variant="primary"
                        buttonStyle="ghost"
                        className={`hover:text-primary ${activeTab === MembersTab.Caregivers ? "text-limestone-900" : "text-text-secondary"}`}
                        onClick={() => setActiveTab(MembersTab.Caregivers)}
                      />
                    ),
                  },
                ]
              : []),
          ]}
        />
        {activeTab === MembersTab.Providers ? (
          <ProvidersTab buttonContainer={buttonContainer} />
        ) : (
          <CaregiversTab buttonContainer={buttonContainer} />
        )}
      </div>
    </div>
  );
};
